import { QuestionBase } from './question-base.model';

export class SignatureQuestion extends QuestionBase<string> {
   controlType = 'signature';
   objectData: string;
   name: any;
   type: any;
   visible: boolean;
   required: boolean;
   constructor(options: {} = {}) {
      super(options);
      this.name = options['name'] || '';
      this.type = options['type'] || 'string';
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.required = (options['required'] == undefined) ? false : options['required'];
   }
}